module.exports = __webpack_public_path__ + "static/media/footer-bckg.328d6d72.png";